/**
 * ManifestProvider — passthrough wrapper for marketing-website PWA
 * manifest mounting.
 *
 * The actual PWA manifest link (`<link rel="manifest" href="/site.webmanifest" />`)
 * is shipped statically in each app's `marketing.html`. This component
 * exists as a stable mount point so dynamic manifest variants (e.g.
 * dark-mode theme overrides, per-locale manifest swaps) can be added
 * later without changing route trees.
 *
 * @module @puffin-core/marketing-shell/ManifestProvider
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode}
 */
export default function ManifestProvider({ children }) {
  return children;
}

ManifestProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
